import React, { useEffect } from 'react';
import Fab from '@material-ui/core/Fab';
import TextsmsOutlinedIcon from '@material-ui/icons/TextsmsOutlined';
import ChatBox from '../ChatBox';
import Zoom from '@material-ui/core/Zoom';
import { Box, useTheme } from '@material-ui/core';

type Position = {
  left?: number;
  right?: number | string;
  top?: number;
  bottom?: number;
};

interface IChatFloatingProps {
  chatgroupId: null | string;
  chatBoxPosition?: Position;
  buttonPosition?: Position;
  initialOpen?: boolean;
}

const ChatFloating = ({
  chatgroupId,
  buttonPosition,
  chatBoxPosition,
  initialOpen,
}: IChatFloatingProps) => {
  const [open, setOpen] = React.useState(initialOpen ?? false);
  const theme = useTheme();

  const onButtonClick = React.useCallback(() => {
    setOpen((open) => !open);
  }, [setOpen]);

  return (
    <div>
      {open && chatgroupId ? (
        <AbsoluteBox position={chatBoxPosition}>
          <ChatBox
            open={open}
            onClose={() => {
              setOpen(false);
            }}
            chatgroupId={chatgroupId}
          />
        </AbsoluteBox>
      ) : (
        <ChatFloatingPure
          onClick={onButtonClick}
          disabled={Boolean(!chatgroupId)}
          buttonPosition={buttonPosition}
        />
      )}
    </div>
  );
};

interface IControlledChatFloatingProps {
  chatgroupId: null | string;
  chatBoxPosition?: Position;
  buttonPosition?: Position;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
export const ControlledChatFloating = ({
  chatgroupId,
  buttonPosition,
  chatBoxPosition,
  open,
  setOpen,
}: IControlledChatFloatingProps) => {
  const theme = useTheme();

  const onButtonClick = React.useCallback(() => {
    setOpen((open) => !open);
  }, [setOpen]);

  return (
    <div>
      {open && chatgroupId ? (
        <AbsoluteBox position={chatBoxPosition}>
          <ChatBox
            open={open}
            onClose={() => {
              setOpen(false);
            }}
            chatgroupId={chatgroupId}
          />
        </AbsoluteBox>
      ) : (
        <ChatFloatingPure
          onClick={onButtonClick}
          disabled={Boolean(!chatgroupId)}
          buttonPosition={buttonPosition}
        />
      )}
    </div>
  );
};

export interface IAbsoluteBoxProps {
  children: React.ReactElement;
  position?: Position;
}

export const AbsoluteBox = ({ children, position }: IAbsoluteBoxProps) => {
  const theme = useTheme();

  return (
    <Box
      style={{
        position: 'fixed',
        top: position?.top,
        right: position?.right ?? theme.spacing(2),
        left: position?.left,
        bottom: position?.bottom ?? theme.spacing(2),
      }}
    >
      {children}
    </Box>
  );
};

interface IChatFloatingPureProps {
  buttonPosition?: Position;
  onClick: () => void;
  disabled?: boolean;
}

export const ChatFloatingPure = ({
  buttonPosition,
  onClick,
  disabled,
}: IChatFloatingPureProps) => {
  const theme = useTheme();

  const transitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen,
  };

  return (
    <AbsoluteBox position={buttonPosition}>
      <Zoom
        in={true}
        timeout={transitionDuration}
        style={{
          transitionDelay: `${transitionDuration.exit}ms`,
        }}
        unmountOnExit
      >
        <Fab
          onClick={onClick}
          disabled={disabled}
          color="primary"
          aria-label="add"
        >
          <TextsmsOutlinedIcon />
        </Fab>
      </Zoom>
    </AbsoluteBox>
  );
};

export default ChatFloating;
